import {
    Routes,
    Route,
    BrowserRouter,
    Navigate
} from "react-router-dom";

import adminDashboardRoutes from "./routes";
import AuthWrapper from "./components/pages/authentication/AuthWrapper";
import { useAppDispatch } from "./hooks/redux/hooks";
import { useEffect } from "react";
import { setSearchValue } from "./store/searchValue/searchValueSlice";

function Router() {
    const dispatch = useAppDispatch();

    useEffect(() => {
        const clearSearchOnRouteChange = () => {
            dispatch(setSearchValue(""));
        };

        window.addEventListener("popstate", clearSearchOnRouteChange);
        window.addEventListener("pushstate", clearSearchOnRouteChange);

        return () => {
            window.removeEventListener("popstate", clearSearchOnRouteChange);
            window.removeEventListener("pushstate", clearSearchOnRouteChange);
        };
    }, [dispatch]);

    const publicRoutes = ["/sign-in", "/sign-up"];

    return (
        <BrowserRouter>
            <Routes>

                {/* / → /sign-in */}
                <Route
                    path="/"
                    element={<Navigate to="/sign-in" replace />}
                />

                {adminDashboardRoutes.map((route, index) => {
                    const isPublicRoute = publicRoutes.includes(route.path);

                    return (
                        <Route
                            key={index}
                            path={route.path}
                            element={
                                isPublicRoute ? (
                                    <route.element />
                                ) : (
                                    <AuthWrapper>
                                        <route.element />
                                    </AuthWrapper>
                                )
                            }
                        />
                    );
                })}

            </Routes>
        </BrowserRouter>
    );
}

export default Router;